import { normalizedTranslate } from '@rbilabs/components-library';
import styled, { RuleSet, css } from 'styled-components';

import { brandFont } from 'components/layout/brand-font';
import { RawPicture } from 'components/raw-picture';
import { primitive } from 'styles/constants/primitives';

export { ImageHalf, TextHalf, EqualHalves } from './containers';

export { default as BackgroundPicture } from './background-picture';
export { Section } from './section';

export const AppStores = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;

  & > * {
    margin-block: 0;
    margin-inline-start: ${primitive.$spacing2};
    margin-inline-end: 0;

    &:first-of-type {
      margin-inline-start: 0;
    }
  }
`;

const baseBadgeStyles = css`
  display: flex;
  justify-content: center;
  align-content: center;
  background: transparent;
  border-radius: ${Styles.borderRadius};

  a {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const AppStoreBadgeContainer = styled.div<{ badgeStyles?: RuleSet }>`
  ${baseBadgeStyles}
  ${Styles.mobile} {
    display: ${~navigator.appVersion.indexOf('Android') ? 'none' : 'block'};
  }

  ${props => props.badgeStyles}
`;

export const GooglePlayBadgeContainer = styled.div<{ badgeStyles?: RuleSet }>`
  ${baseBadgeStyles}
  ${props => props.badgeStyles}
`;

export const HuaweiBadgeContainer = styled.div<{ badgeStyles?: RuleSet }>`
  ${baseBadgeStyles}
  ${props => props.badgeStyles}
`;

export const ConfettiLeft = styled.div`
  position: absolute;
  width: 110px;
  inset-block-start: 0;
  inset-inline-end: calc(50% + 90px);
  transform: ${normalizedTranslate(0, '-130%')};

  ${Styles.desktop} {
    inset-inline-end: auto;
    inset-inline-start: 0;
    width: 25%;
    width: 25%;
    inset-block-start: 50%;
    transform: ${normalizedTranslate('-125px', '-75px')};
  }
`;

export const ConfettiRight = styled.div`
  position: absolute;
  width: 140px;
  inset-block-start: 0;
  inset-inline-start: calc(50% + 110px);
  transform: ${normalizedTranslate(0, '-200%')};

  ${Styles.desktop} {
    inset-inline-start: auto;
    inset-inline-end: 0;
    width: 33%;
    transform: ${normalizedTranslate('165px', '32px')};
  }
`;

// BK & PLK STYLES

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  width: 100%;
  max-width: 23rem;
  text-align: center;
  color: ${p => p.theme.token('text-default')};

  ${Styles.desktop} {
    text-align: start;
    align-items: flex-start;
    max-width: 28.125rem;
  }

  & > form {
    ${Styles.desktop} {
      margin-inline-start: 0;
      width: 100%;
      justify-content: flex-start;
    }
  }
`;

export const headerStyles = css`
  font: ${brandFont.hero};
  letter-spacing: 'normal';
  text-transform: ${Styles.textTransform.headlines};
  margin: 0 auto;

  ${Styles.desktop} {
    margin-inline-start: 0;
  }
`;

export const SuperHeader = styled.h2`
  ${headerStyles}
  margin-block-end: ${primitive.$spacing1};
`;

export const Header = styled.h2`
  ${headerStyles}
  margin-block-end: ${primitive.$spacing5};
`;

export const Description = styled.p`
  font: ${brandFont.copyOne};
  margin-block-start: 0;
  margin-block-end: ${primitive.$spacing7};
  margin-inline: auto;

  ${Styles.desktop} {
    margin-inline-start: 0;
  }
`;

export const MainImageContainer = styled.div`
  max-width: 300px;
  width: 100%;
  margin: auto;

  picture > * {
    height: auto;
    inset-block-start: ${primitive.$spacing8};
  }

  ${Styles.desktop} {
    display: flex;
    justify-content: flex-end;
    position: absolute;
    max-width: none;
    width: 30rem;
    height: 39.75rem;
    margin-inline-end: 0;

    picture > * {
      height: 100%;
      object-position: bottom;
    }
  }
`;

export const BadgesContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${Styles.desktop} {
    flex-direction: row;
  }

  & div:first-child img {
    height: 43px;
  }
`;

export const BadgeImage = styled(RawPicture)`
  width: 160px;
`;

export const appleBadgeStyles = css`
  margin-block-start: 0;
  margin-block-end: ${primitive.$spacing3};
  margin-inline: auto;

  ${Styles.desktop} {
    margin: 0;
    margin-inline-end: ${primitive.$spacing3};
  }
`;

export const googleBadgeStyles = css`
  margin: auto;

  ${Styles.desktop} {
    margin: 0;
  }
`;

export const HuaweiImage = styled(RawPicture)`
  margin-block-start: 0.875rem;
  height: 2.75rem;
  padding-inline-end: 0.875rem;

  ${Styles.desktop} {
    margin-block-start: 0;
    max-width: 10.375rem;
    padding-inline-start: 1.25rem;
    padding-inline-end: 0;
  }
`;

export const Disclaimer = styled.div`
  margin-block-start: ${primitive.$spacing7};
  margin-block-end: 0;
  margin-inline: 0;
  color: ${p => p.theme.token('text-default')};
  font: ${brandFont.copyTwo};

  a {
    color: ${p => p.theme.token('text-default')};
  }
`;
